"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.stripHtmlFromString = stripHtmlFromString;

function stripHtmlFromString(string) {
  if (!string) return string;
  var doc = new DOMParser().parseFromString(string, 'text/html');
  return doc.body.textContent || '';
}